var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "panel wraper panel-gray" },
    [
      _c("div", { staticClass: "panel-header" }, [
        _c("div", { staticClass: "panel-title" }, [_vm._m(0)], 1)
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "panel-body", attrs: { id: "formbody" } },
        [
          _c(
            "q-field",
            {
              attrs: {
                error: _vm.$v.tempInstrument.name.$error,
                "error-label": _vm._f("errorLabel")(_vm.$v.tempInstrument.name)
              }
            },
            [
              _c(
                "q-input",
                {
                  attrs: { "float-label": "Название" },
                  model: {
                    value: _vm.tempInstrument.name,
                    callback: function($$v) {
                      _vm.$set(
                        _vm.tempInstrument,
                        "name",
                        typeof $$v === "string" ? $$v.trim() : $$v
                      )
                    },
                    expression: "tempInstrument.name"
                  }
                },
                [
                  _c("q-autocomplete", {
                    attrs: {
                      "static-data": { field: "value", list: _vm.names }
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "q-field",
            [
              _c("q-input", {
                attrs: { "float-label": "Серийный номер" },
                model: {
                  value: _vm.tempInstrument.serial,
                  callback: function($$v) {
                    _vm.$set(
                      _vm.tempInstrument,
                      "serial",
                      typeof $$v === "string" ? $$v.trim() : $$v
                    )
                  },
                  expression: "tempInstrument.serial"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "q-field",
            [
              _c("q-datetime", {
                attrs: {
                  "float-label": "Дата установки",
                  clearable: "",
                  popover: "",
                  "first-day-of-week": 1,
                  format: "DD.MM.YYYY"
                },
                model: {
                  value: _vm.tempInstrument.dateInstall,
                  callback: function($$v) {
                    _vm.$set(_vm.tempInstrument, "dateInstall", $$v)
                  },
                  expression: "tempInstrument.dateInstall"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "q-field",
            [
              _c("q-input", {
                attrs: { type: "textarea", rows: 1, "float-label": "Заметки" },
                model: {
                  value: _vm.tempInstrument.comment,
                  callback: function($$v) {
                    _vm.$set(
                      _vm.tempInstrument,
                      "comment",
                      typeof $$v === "string" ? $$v.trim() : $$v
                    )
                  },
                  expression: "tempInstrument.comment"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("save-btn", {
        attrs: {
          notChanged: _vm.notChanged,
          goView: _vm.goView,
          doSave: _vm.doSave
        }
      })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("unit-path", {
      attrs: { id: _vm.iniInstrument.parent_id, lbl: _vm.lbl }
    })
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-44615070", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-44615070","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/instrument-edit.vue
// module id = null
// module chunks = 